import { render, staticRenderFns } from "./FileUploadFarm.vue?vue&type=template&id=5c0531b1&scoped=true&"
import script from "./FileUploadFarm.vue?vue&type=script&lang=ts&"
export * from "./FileUploadFarm.vue?vue&type=script&lang=ts&"
import style0 from "./file-upload-farm.scss?vue&type=style&index=0&id=5c0531b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0531b1",
  null
  
)

export default component.exports